export enum ParticipantUpdateType {
  Adding = 'adding',
  Removing = 'removing',
}

export type ParticipantUpdate = { id: string; type: ParticipantUpdateType };
